import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "LTDCModeler" })((_theme, toCompare) => ({
  page: {
    margin: "20px",
  },
  LTDCModelerCardResponsive: {
    width: toCompare ? "48%" : "100%",
    [`@media (max-width:1060px)`]: {
      width: "100%",
    },
  },
  LTDCModelerExportBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "10px",
    marginTop:  "-30px",
  },
  SaveBtn: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "40px",
    marginTop: "10px",
  },
}));
